export const ga4 = {
    name: 'GA4',
    key: 'ga4',
    assets: {
        icon: '/images/competitors/ga4.svg',
        comparisonArticle: '/blog/posthog-vs-ga4',
    },
    products: {
        product_analytics: {
            available: true,
            features: {
                advertising_analytics: true,
                autocapture: true,
                cohorts: true,
                custom_events: true,
                custom_properties: true,
                monetization_analytics: true,
                predictive_insights: true,
                real_time_view: true,
                toolbar: false,
                user_profiles: 'Anonymous',
                trends: {
                    available: true,
                    features: {},
                },
                funnels: {
                    available: true,
                    features: {
                        conversion_funnels: true,
                        correlation_analysis: false,
                    },
                },
                retention: {
                    available: true,
                    features: {},
                },
                user_paths: {
                    available: true,
                    features: {},
                },
                lifecycle: {
                    available: false,
                    features: {},
                },
                stickiness: {
                    available: false,
                    features: {},
                },
                group_analytics: {
                    available: false,
                    features: {},
                },
                insights: {
                    available: true,
                    features: {
                        ai_insight_builder: true,
                        formula_mode: false,
                        ready_made_insight_types: true,
                        sampling: false,
                        sql_editor: false,
                    },
                },
            },
        },
        heatmaps: {
            available: false,
            features: {
                clickmaps: false,
                heatmaps: false,
                scrollmaps: false,
                movement_maps: false,
            },
        },
        web_analytics: {
            available: true,
            features: {
                advertising_analytics: false,
                bounce_rate: false,
                bounce_rate_tracking: true,
                breakdown_by_device_and_browser: true,
                breakdown_by_geoip: true,
                conversions: false,
                cookieless_tracking: true,
                custom_channel_types: false,
                entry_exit_paths: false,
                first_party_cookies: true,
                hipaa_compliance: false,
                integration_with_feature_flags: false,
                integration_with_session_replay: false,
                integration_with_surveys: false,
                migration: false,
                movement_maps: false,
                open_source: false,
                outbound_clicks: false,
                pageviews: false,
                pre_configured_dashboards: true,
                real_time_reporting: true,
                revenue_tracking: true,
                script_size: false,
                search_tools: true,
                session_and_duration_tracking: true,
                sessions: false,
                snippet_install: false,
                traffic_breakdown: true,
                utm_tracking: true,
                visitor_and_view_tracking: true,
                web_vitals: false,
                web_vitals_reporting: true,
            },
        },
        session_replay: {
            available: false,
        },
        feature_flags: {
            available: false,
        },
        experiments: {
            available: false,
        },
        surveys: {
            available: false,
        },
        cdp: {
            available: false,
        },
        data_warehouse: {
            available: false,
        },
        dashboards: {
            available: true,
        },
    },
    platform: {
        analytics_integration: {
            built_in_analytics: false,
        },
        deployment: {
            eu_hosting: false,
            open_source: false,
            reverse_proxy: false,
            self_host: false,
        },
        developer: {
            api: false,
            mobile_sdks: false,
            server_side_sdks: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            bigquery: true,
            customer_io: false,
            datadog: false,
            email_reports: true,
            google_ads: true,
            google_search_console: true,
            hubspot: false,
            intercom: false,
            salesforce: false,
            sentry: false,
            stripe: true,
            self_serve: true,
            zapier: true,
        },
        pricing: {
            free_tier: true,
            self_serve: true,
            usage_based_pricing: false,
            transparent_pricing: false,
        },
        security: {
            cookieless_tracking: false,
            data_anonymization: true,
            gdpr_ready: false,
            hipaa_ready: false,
            role_based_access_control: true,
            saml_sso: true,
            soc2_certified: false,
            security_certification: 'ISO 27001',
            two_factor_auth: true,
        },
    },
    pricing: {
        model: 'Free',
    },
}
